import React from "react";
import styled from "styled-components";
import breakpoint from "styled-components-breakpoint";
import Introduce from "../../components/Introduce";
import ProductCard from "../../components/ProductCard";
import PeopleCard from "../../components/PeopleCard";
import _ from "lodash";
import useIsPhone from "../../hooks/useIsPhone";
import { Rem } from "@fe_utils/fe_sdk_base";
import AutoScrollingScrollView from "../../components/AutoScrollingScrollView";
import { appInfoList, coreTeamList } from "./config";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay, Navigation, Pagination } from "swiper";
import "swiper/swiper-bundle.css";

SwiperCore.use([Autoplay, Navigation, Pagination]);

const LingGanSeries = ({ heroTitleLevel = "h1" }) => {
  const isPhone = useIsPhone();
  const HeroTitle = heroTitleLevel;
  if (isPhone) {
    Rem.init(37.5, 1, false);
  } else {
    Rem.resetRem(50);
  }
  return (
    <Wrapper>
      <HeroTitle className="sr-only">移动智能工具领域创新者</HeroTitle>
      <img
        className="head_bg"
        src={
          isPhone
            ? require("./images/linggan_series_head_bg.png")
            : require("./images/linggan_series_head_desktop_bg.png")
        }
        alt=""
      />
      <Introduce
        title={"我们的产品"}
        src={require("./images/our_products_title.png")}
        backgroundColor={"#FFFFFF"}
        alt={"我们的产品"}
      >
        <OurProducts>
          {isPhone ? (
            <AutoScrollingScrollView>
              {_.map(appInfoList, (item) => (
                <ProductCard
                  style={{ margin: "12px" }}
                  {...item}
                  key={item.appName}
                ></ProductCard>
              ))}
            </AutoScrollingScrollView>
          ) : (
            <ProductCardWrapper>
              {_.map(appInfoList, (item) => (
                <ProductCard {...item} key={item.appName}></ProductCard>
              ))}
            </ProductCardWrapper>
          )}
        </OurProducts>
      </Introduce>
      <Introduce
        title={"公司介绍"}
        src={require("./images/about_us_title.png")}
        backgroundColor={"#FFFCF5"}
        alt={"公司介绍"}
      >
        <CompanyProfile>
          <div className="linggan_introduce">
            <span>灵敢</span>
            专注打造移动端智能工具矩阵，以产品和技术创新大幅提升垂直领域的体验和效率，是中国移动智能工具领域的非常接地气的创新者。
            <br /> <br />
            “灵敢“是北京夕航科技旗下品牌。夕航科技成立于2018年，是国家高新技术企业、北京市“专精特新”企业，拥有近百项核心知识产权，在成立之初就获得了国内知名投资机构的投资。
          </div>
          <img
            className="certificate"
            src={require("./images/certificate.png")}
            alt="北京夕航科技有限公司的国家高新技术企业证书，以及北京市“专精特新”中小企业证书"
          />
        </CompanyProfile>
      </Introduce>
      <Introduce
        title={"灵敢团队介绍"}
        src={require("./images/core_team_title.png")}
        backgroundColor={"#FFFFFF"}
        alt={"灵敢团队介绍"}
      >
        <CoreTeam>
          {isPhone ? (
            <PeopleSwiper
              spaceBetween={24}
              slidesPerView={"auto"}
              centeredSlides={true}
              loop={true}
              loopedSlides={3}
              autoplay={{ delay: 3000, disableOnInteraction: false }}
              pagination={{
                clickable: true,
              }}
            >
              {_.map(coreTeamList, (item) => (
                <SwiperSlide key={item.name}>
                  <PeopleCard {...item}></PeopleCard>
                </SwiperSlide>
              ))}
            </PeopleSwiper>
          ) : (
            <div className="core_team_list">
              {_.map(coreTeamList, (item, index) => (
                <PeopleCard {...item} key={index}></PeopleCard>
              ))}
            </div>
          )}
        </CoreTeam>
      </Introduce>
    </Wrapper>
  );
};

export default LingGanSeries;

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  > .head_bg {
    width: 100%;
  }
`;
const OurProducts = styled.div`
  margin-top: 24px;
  margin-bottom: 68px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const ProductCardWrapper = styled.div`
  display: flex;
  align-items: center;
  > div {
    margin: 12px;
  }
`;
const PeopleSwiper = styled(Swiper)`
  width: 100%;
  margin: 0;
  overflow: hidden;
  > .swiper-wrapper {
    margin-top: 26px;
    width: 260px;
    height: 480px;
    > .swiper-slide {
      width: 100%;
    }
  }
  > .swiper-pagination {
    z-index: 9999;
    position: absolute;
    top: 438px;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .swiper-pagination-bullet {
      width: 6px;
      height: 6px;
      background: #2c2e34;
      border-radius: 3px;
      opacity: 0.1;
      margin-right: 8px;
      transition: all 0.3s ease-in-out;
      &:last-child {
        margin-right: 0;
      }
    }
    .swiper-pagination-bullet-active {
      width: 24px;
      height: 6px;
      background: #ffab18;
      border-radius: 3px;
      opacity: 1;
    }
  }
`;
const CompanyProfile = styled.div`
  margin-top: 26px;
  > .linggan_introduce {
    text-align: justify;
    padding: 0 30px;
    font-size: 14px;
    line-height: 28px;
    > span {
      font-weight: 600;
      font-size: 28px;
      color: #2c2e34;
    }
  }
  > .certificate {
    margin-bottom: 48px;
    padding: 0 10px;
    width: 100%;
  }
  ${breakpoint("desktop")`
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    > .linggan_introduce {
     width: 692px;
     line-height: 24px;
     margin-right: 16px;
     > span {
       font-size: 25px;
     }
    }
    > .certificate {
     width: 252px;
     }
    `}
`;
const CoreTeam = styled.div`
  width: 100%;
  > .core_team_text {
    text-align: center;
    font-weight: 700;
    font-size: 14px;
    color: #2c2e34;
    line-height: 20px;
    > span {
      color: #ff7f19;
    }
  }
  ${breakpoint("desktop")`
    > .core_team_list {
      margin: 59px 0 46px 0;
      display: flex;
      justify-content: center;
      > div {
        margin: 0 12px;
      }
    }
    > .core_team_text {
      font-size: 13px;
      line-height: 19px;
    }
  `}
`;
